import type { BrandName } from "@rally/ui-kit";
import { providerSaid } from "./a-provider-is-a-company.ts";

export type AgentsMarks = { glyph?: BrandName; mark?: BrandName };

const BY_MODEL: Array<{ says: RegExp; glyph: BrandName; mark: BrandName }> = [
  { says: /^claude/, glyph: "claude", mark: "anthropic" },
  { says: /^(gpt|o[13]|codex)/, glyph: "openai", mark: "openai" },
  { says: /^gemini/, glyph: "google", mark: "google" },
];

export function theMarkForAnAgent(model: string, provider?: string | null): BrandName | undefined {
  return theMarksOfAnAgent(model, provider).mark;
}

export function theMarksOfAnAgent(model: string, provider?: string | null): AgentsMarks {
  const named = model.trim().toLowerCase();
  const known = BY_MODEL.find((one) => one.says.test(named));
  if (known) return { glyph: known.glyph, mark: known.mark };
  const held = (provider ? providerSaid(provider).mark : null) as BrandName | null;
  return held ? { mark: held } : {};
}

export function faceOfAnAgent(
  model: string | null | undefined,
  provider?: string | null,
): { shape: "square"; glyph?: BrandName; mark?: BrandName } {
  return { shape: "square", ...(model ? theMarksOfAnAgent(model, provider) : {}) };
}
